import { Controller } from '@hotwired/stimulus';




// This functionality is not working we stop it in task DDT-2638, by requirment we wont remove it because we may use it in the feature




/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'profile--edit-recruitment-modal',
    ];

    openModal(event) {
        event.preventDefault();

        this.profileEditRecruitmentModalOutlet.openModal();
    }
}
